import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const InputContainer = styled(Box)`
  flex: 1 1 auto;
`;
export const SaveButtonContainer = styled(Box)`
  flex: 0 0 auto;
`;
export const FormContainer = styled(Box).attrs({
  p: '10px',
})`
  border: ${p => `1px solid ${p.theme.colors.heavyLineOutline}`};
`;
